import { notification } from 'components/Notification'
import { VALIDATION_MESSAGES } from 'constants/txt'
import { TRebatePaymentData } from './types'

export const validateRebatesPaymentData = (
  rebatePaymentData: TRebatePaymentData
) => {
  if (!rebatePaymentData.vendor_data.has_linked_bank_accounts) {
    notification.error({
      message: VALIDATION_MESSAGES.SM0240
    })
    return false
  }
  if (!rebatePaymentData.vendor_data.has_verified_payable_accounts) {
    notification.error({
      message: VALIDATION_MESSAGES.SM0241
    })
    return false
  }
  if (!rebatePaymentData.hospital_data.has_receivable_account) {
    notification.error({
      message: VALIDATION_MESSAGES.SM0242
    })
    return false
  }
  if (!rebatePaymentData.hospital_data.has_default_receivable_account) {
    notification.error({
      message: VALIDATION_MESSAGES.SM0242
    })
    return false
  }
  if (
    !rebatePaymentData.hospital_data.default_receivable_has_ach_credit_standard
  ) {
    notification.error({
      message: VALIDATION_MESSAGES.SM0241
    })
    return false
  }
  return true
}
